import React, { useEffect, useState, useRef } from "react";
import { Box, Button, TextField, Typography, IconButton } from "@mui/material";
import {
  AttachFile,
  Link,
  Image,
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  Add,
} from "@mui/icons-material";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import SnackbarContent from "components/Snackbar/SnackbarContent";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_ERROR } from "redux/actions";
import { ANNOUNCEMENT_GET_ALL_REQUESTED } from "redux/actions";
import { FILE_UPLOAD_URL } from "scripts/const";
import axios from "axios";
import imageCompression from "browser-image-compression";

import { TENANT } from "scripts/const";
import { Editor } from "@tinymce/tinymce-react";
import { TINY_INIT } from "scripts/const";
import ConfirmationAlert from "components/Alert/ConfirmationAlert";

const UpdateAnnouncement = (props) => {
  const [alert, setAlert] = React.useState(null);
  const [isSaving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [announcement, setAnnouncement] = useState({});
  const imageInputRef = useRef(null);
  const attachFileInputRef = useRef(null);

  const hideAlert = () => {
    setAlert(null);
  };

  const handleImageIconClick = () => {
    imageInputRef.current.click();
  };

  const handleAttachFileIconClick = () => {
    attachFileInputRef.current.click();
  };

  const dispatch = useDispatch();

  const saveError = useSelector(
    (state) => state.announcement.announcementCreateError
  );
  const saveSuccess = useSelector(
    (state) => state.announcement.announcementCreateSuccess
  );
  const saveProgress = useSelector(
    (state) => state.announcement.announcementCreateFetching
  );
  const errMsg = useSelector((state) => state.announcement.errorMsg);
  const [errMessage, setErrorMsg] = React.useState(
    "Something went wrong. Please try again."
  );
  useEffect(() => {
    setErrorMsg(errMsg);
  }, [errMsg]);
  useEffect(() => {
    setError(saveError);
  }, [saveError]);

  useEffect(() => {
    setSuccess(saveSuccess);
  }, [saveSuccess]);

  useEffect(() => {
    if (saveSuccess === true) {
      dispatch({ type: ANNOUNCEMENT_GET_ALL_REQUESTED });
      setTimeout(() => {
        dispatch({ type: CLEAR_ERROR });
      }, 701);
    }
  }, [saveSuccess]);

  const handleChange = (e) => {
    setAnnouncement({
      ...announcement,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setSaving(true);
    e.preventDefault();
    let changedFile = e.target.files[0];
    // setFile(changedFile);
    uploadImage(changedFile, (remoteFileUrl) => {
      setAnnouncement((prev) => ({
        ...prev,
        photoURL: remoteFileUrl,
      }));
      setSaving(false);
    });
  };
  function uploadImage(file, callback) {
    const fileUploadUrl = FILE_UPLOAD_URL;

    let remoteFileUrl = null;
    if (file) {
      const fileName = file.name;
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };
      imageCompression(file, options)
        .then(function (compressedFile) {
          axios
            .post(fileUploadUrl, {
              name: fileName,
              folder: `${TENANT}/announcement`,
            })
            .then(function (response) {
              const responseBody = response.data;
              const formData = new FormData();
              Object.keys(responseBody.fields).forEach((key) => {
                formData.append(key, responseBody.fields[key]);
              });
              formData.append("file", compressedFile);
              const uploadURL = responseBody.url;
              remoteFileUrl = responseBody.fileUrl;
              axios
                .post(uploadURL, formData)
                .then(function () {
                  callback(remoteFileUrl);
                })
                .catch(function (error) {
                  console.log("Image Upload error: ", error);
                });
            })
            .catch(function (error) {
              console.log("Image Upload error: ", error);
            });
        })
        .catch(function (error) {
          console.log("Error: ", error.message);
          setSaving(false);
        });
    } else {
      dispatch({
        type: CLEAR_ERROR,
      });
    }
  }
  const handleEditorChange = (content) => {
    setAnnouncement({
      ...announcement,
      description: content,
    });
  };
  return (
    <Box
      sx={{
        width: "500px",
        margin: "20px auto",
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        boxShadow: 3,
      }}
    >
      <Typography variant="h6" sx={{ marginBottom: "16px" }}>
        Update and Announcement
      </Typography>
      <GridContainer>
        {alert}

        <GridItem xs={12} sm={12} md={12}>
          {error && <SnackbarContent message={errMessage} color="warning" />}
          {saveProgress && <CustomLinearProgress color="primary" />}
          {success && (
            <SnackbarContent message="Added the announcement" color="success" />
          )}
        </GridItem>
      </GridContainer>
      <TextField
        onChange={(e) => handleChange(e)}
        name="title"
        value={announcement.title}
        fullWidth
        variant="outlined"
        label="Subject"
        sx={{ marginBottom: "16px" }}
      />
      <Box>
        <Editor
          licenseKey={"gpl"}
          tinymceScriptSrc={
            "https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.1.2/tinymce.min.js"
          }
          value={announcement.description || ""}
          init={TINY_INIT}
          onEditorChange={handleEditorChange}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={handleImageIconClick}>
              <input
                ref={imageInputRef}
                type="file"
                style={{ display: "none" }}
                accept="image/jpeg"
                onChange={handleFileChange}
              />

              <Image />
            </IconButton>

            <IconButton onClick={handleAttachFileIconClick}>
              <input
                accept=".pdf"
                ref={attachFileInputRef}
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <AttachFile />
            </IconButton>
            {/* <IconButton>
              <Add />
            </IconButton> */}
          </Box>
          <IconButton sx={{ marginLeft: "auto" }}></IconButton>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          disabled={isSaving}
          onClick={() => {
            setAlert(
              <ConfirmationAlert
                cancel={hideAlert}
                submit={() => {
                  props.handleCreate(announcement);
                  setAnnouncement({ title: "", description: "", photoURL: "" });
                }}
                message={"You are publishing announcement"}
                style={{
                  display: "block",
                }}
              />
            );
          }}
          variant="contained"
          color="primary"
        >
          Publish
        </Button>
      </Box>
    </Box>
  );
};

export default UpdateAnnouncement;
